import React, { Component } from 'react';


const createLabels = (arr, labelActiva, funcionSeleccion) => {
    return arr.map(lab => {
        return <div onClick={() => funcionSeleccion(lab)} className={lab == labelActiva ? "tabErroresProcesosActive" : "tabErroresProcesosDisabled"}>{lab}</div>
    })
}

class ControlesSuperiores extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.RecorrerTabla = this.RecorrerTabla.bind(this);
        this.validarProcesoEnEjecucion= this.validarProcesoEnEjecucion.bind(this);
    }

    validarProcesoEnEjecucion(esReproceso) {
        this.props.validarProcesoEnEjecucion(esReproceso);
    }

    RecorrerTabla() {
        this.props.RecorrerTabla();
    }

    ExportarExcel() {
        this.props.DescargarExcelErroresYNotas(this.props.erroresProceso);
    }

    volver(){
        this.props.getErroresProceso(false);
    }

    render() {
        let labels;
        const { IdProcesoEstado, IdProcesoTraza } = this.props

        if (this.props.labels) {
            labels = createLabels(this.props.labels, this.props.labelActiva, this.props.seleccionarTabError);
        }

        let esReprocesable = IdProcesoEstado == 10 && this.props.erroresProceso[0].ProcesoTrazaId == IdProcesoTraza

        return (
            <div className='barraControlesSuperioresErroresProcesos'> 
                <div className='CuentaSeleccionContainer labelsErroresProcesos'>
                    {labels}
                </div>
                <div className="procesoColumnLeft">
                    <button onClick={() => esReprocesable ? this.props.mostrarModal(4, true) : this.volver()} className='btn btn-default btn-secondary'>Cerrar</button>
                    {esReprocesable &&
                        <button onClick={() => this.validarProcesoEnEjecucion(true)} className='btn btn-primary btn-cta'>Reprocesar</button>
                    }
                    <div onClick={() => this.ExportarExcel()} className='botonExcel'></div>
                </div>
            </div>
        );
    }
}

export default ControlesSuperiores;